/**
 * @generated SignedSource<<3eec93f48af8128694a0d31cb817743e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EquipmentCategory = "AUDIO_VIDEO" | "BATTERY" | "CABLE" | "CAMERA" | "CAMERA_ACCESSORY" | "ETC" | "KIT" | "LENS" | "LIGHTING" | "MEDIA" | "NETWORK" | "POWER" | "PRINTER" | "SECURITY" | "WORKSTATION" | "WORKSTATION_ACCESSORY" | "%future added value";
export type AssetReturnLookupQuery$variables = {
  assetTag: any;
};
export type AssetReturnLookupQuery$data = {
  readonly lostAsset: {
    readonly assetTag: any;
    readonly category: EquipmentCategory;
    readonly image: any | null | undefined;
    readonly name: string;
    readonly reportedLost: boolean;
  } | null | undefined;
};
export type AssetReturnLookupQuery = {
  response: AssetReturnLookupQuery$data;
  variables: AssetReturnLookupQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assetTag"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "assetTag",
        "variableName": "assetTag"
      }
    ],
    "concreteType": "LostAsset",
    "kind": "LinkedField",
    "name": "lostAsset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "assetTag",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "image",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reportedLost",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetReturnLookupQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssetReturnLookupQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "88bb6384787427419ea7e56d42fe4237",
    "id": null,
    "metadata": {},
    "name": "AssetReturnLookupQuery",
    "operationKind": "query",
    "text": "query AssetReturnLookupQuery(\n  $assetTag: AssetTag!\n) {\n  lostAsset(assetTag: $assetTag) {\n    assetTag\n    name\n    category\n    image\n    reportedLost\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c6330efb8fc0717a1415e6b04fc7b2b";

export default node;
